__turbopack_context__.v({
  "tabList": "gu1CSW_tabList",
});
